import { FC } from "react";
import { useTranslation } from "react-i18next";
import UiModal from "@dashboard/components/ui-modal/ui-modal";
import { Order } from "@dashboard/modules/orders/types/order.types";
import { DeliveryOrderPickerModalWrapper } from "./delivery-order-picker-modal.styled";

type DeliveryOrderPickerModalProps = {
  show: boolean;
  orders: Order[];
  loading: boolean;
  error: string | null;
  onClose: () => void;
  onSelect: (order: Order) => void;
  onRetry: () => void;
};

export const DeliveryOrderPickerModal: FC<DeliveryOrderPickerModalProps> = ({
  show,
  orders,
  loading,
  error,
  onClose,
  onSelect,
  onRetry,
}) => {
  const { t } = useTranslation();

  return (
    <UiModal show={show} onClose={onClose} className="delivery-order-picker-modal">
      <DeliveryOrderPickerModalWrapper>
        <h3>{t("delivery.home.orderPicker.title")}</h3>

        {loading && <p className="empty-text">...</p>}

        {!loading && error && (
          <p className="error-text">
            {error}{" "}
            <button type="button" className="link-button" onClick={onRetry}>
              {t("delivery.home.orderPicker.retry")}
            </button>
          </p>
        )}

        {!loading && !error && orders.length === 0 && (
          <p className="empty-text">{t("delivery.home.orderPicker.empty")}</p>
        )}

        {!loading && !error && orders.length > 0 && (
          <ul className="order-list">
            {orders.map((order) => (
              <li key={order.id}>
                <button
                  type="button"
                  className="order-item"
                  onClick={() => onSelect(order)}
                >
                  <span className="order-id">#{order.id}</span>
                  <span className="order-customer">{order.customerName}</span>
                  {order.customerAddress?.city && (
                    <span className="order-city">
                      {order.customerAddress.city}
                    </span>
                  )}
                </button>
              </li>
            ))}
          </ul>
        )}
      </DeliveryOrderPickerModalWrapper>
    </UiModal>
  );
};
